import { FC, ReactElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import {
  AuthForm,
  AuthPageWrapper,
  usernamePasswordFieldsDescription,
} from '@app/components';
import { useAuthentication } from '@app/hooks';
import { sharedMessages } from '@app/translations';
import { LoginMethod, PasswordType, Route } from '@app/constants';

const cnBem = createBemBlockBuilder(['loginPage']);

export const DirectLoginPage: FC = () => {
  const { $t } = useIntl();
  const { notification, isLoading, loginUser } = useAuthentication({
    method: LoginMethod.direct,
    passwordFieldName: PasswordType.password,
  });

  const getSignUpMessage = () =>
    $t(
      {
        id: 'auth.accountDoesntExist',
        defaultMessage: 'Don’t have an account? <a>Sign up.</a>',
      },
      { a: chunks => <Link to={Route.createAccount}>{chunks}</Link> }
    );

  return (
    <>
      <Helmet>
        <title>
          {$t({
            id: 'login.documentTitle',
            defaultMessage: 'Login - EBSCO Locate',
          })}
        </title>
      </Helmet>
      <AuthPageWrapper
        title={$t(sharedMessages.welcomeBack)}
        notification={notification}
        className={cnBem()}
        titlePrompt={getSignUpMessage() as ReactElement}
      >
        <AuthForm
          fields={usernamePasswordFieldsDescription}
          isLoading={isLoading}
          onSubmit={loginUser}
        />
      </AuthPageWrapper>
    </>
  );
};
